import { FormFieldType, FormGroupDirectionType, IFormGroupConfig } from '@shared/ui';

export const authFormConfig: IFormGroupConfig = {
  type: FormFieldType.GROUP,
  direction: FormGroupDirectionType.COLUMN,
  fields: {
    login: {
      type: FormFieldType.INPUT,
      placeholder: 'AUTH_FIELD_LOGIN_PLACEHOLDER',
      hideLabel: true,
      required: true,
    },
    password: {
      type: FormFieldType.PASSWORD,
      placeholder: 'AUTH_FIELD_PASSWORD_PLACEHOLDER',
      hideLabel: true,
      required: true,
    },
  },
};
